import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { api } from "@/shared/api/axios";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Benefits } from "./components/Benefits";
import { HowItWorks } from "./components/HowItWorks";
import { Pricing } from "./components/Pricing";
import { Footer } from "./components/Footer";
import { HelpPanel } from "@/shared/help/components/HelpPanel";
import { PublicSeo } from "../components/PublicSeo";

export function ClinicLandingPage() {
  const { t } = useTranslation(["landing"]);
  useEffect(() => {
    const sessionKey = "fysaro:analytics:landing-visit";

    try {
      if (window.sessionStorage.getItem(sessionKey)) return;
      window.sessionStorage.setItem(sessionKey, "pending");

      void api.post("/analytics/public/landing-visit").then(
        () => window.sessionStorage.setItem(sessionKey, "recorded"),
        () => window.sessionStorage.removeItem(sessionKey),
      );
    } catch {
      // Analytics must never affect the public page when storage is unavailable.
    }
  }, []);

  return (
    <div className="flex flex-col h-screen overflow-hidden bg-background text-foreground custom-scrollbar">
      <PublicSeo
        title={t("landing:seo.clinic_home_title")}
        description={t("landing:seo.clinic_home_description")}
        path="/"
      />
      <Header />
      {/* Contenedor horizontal como en Tenant */}
      <div className="flex flex-1 min-h-0 relative overflow-hidden">
        {/* Contenido público */}
        <main className="flex-1 overflow-y-auto">
          <Hero />
          <Benefits />
          <HowItWorks />
          <Pricing />
          <Footer />
        </main>
        <HelpPanel contextScope="PUBLIC_CLINIC" />
      </div>
    </div>
  );
}
